import React, { useEffect, useState } from "react";
import bed from "../../images/icon_bed.png";
import people from "../../images/icon_people.png";
import icon_size from "../../images/icon_size.png";
import icon_view from "../../images/icon_view.png";
import { Element } from "react-scroll";
import { Fade } from "react-awesome-reveal";
import { useRoomContext } from "../../context/RoomContext";
import { marked } from "marked";

interface IOthersRoom {
  id: number;
}

const RoomInfo = (props: IOthersRoom) => {
  const {roomData} = useRoomContext();
  const filterRoomData = roomData.filter((room) => (room?.id === props.id));
  const [roomDescription, setRoomDescription] = useState<string>("");

  useEffect(() => {
    const loadMarkdown = async () => {
      const description = filterRoomData[0]?.attributes?.Room_Description || "";
      const processedMarkdown = await marked(description);
      setRoomDescription(processedMarkdown);
    };
    
    loadMarkdown();
  }, [filterRoomData]);
  return (
    <>
      <div id="page_content_wrapper" className="blog_wrapper hasbg">
        <div className="inner">
          {/* <!-- Begin main content --> */}
          <div className="inner_wrapper">
            <Element name="singleroom_detail"></Element>
            <div id="singleroom_detail" className="full_width blog_f">
              {/* <!-- Begin each blog post --> */}
              <div
                id="post-150"
                className="post-150 mphb_room_type type-mphb_room_type status-publish has-post-thumbnail hentry mphb_room_type_category-standard-rooms mphb_room_type_tag-deluxe mphb_room_type_tag-standard mphb_room_type_facility-40-inch-samsung-led-tv mphb_room_type_facility-electronic-safe-with-charging-facility mphb_room_type_facility-ihome-bluetooth-mp3-player mphb_room_type_facility-iron-and-ironing-board mphb_room_type_facility-mini-bar mphb_room_type_facility-non-smoking mphb_room_type_facility-usb-charging-station mphb_room_type_facility-wired-and-wireless-broadband-internet-access mphb_room_type_facility-work-desk mphb-room-type-adults-3 mphb-room-type-children-1"
              >
                {filterRoomData.map((room) => (
                  <div className="post_wrapper">
                    <div className="singleroom_two_third themeborder">
                    <Fade cascade damping={0.2} direction="up" triggerOnce={true}>
                      <p>
                        <span style={{ fontSize: "24px", lineHeight: 1.5 }}>
                          <b>{room?.attributes?.Room_Title} </b>
                        </span>
                      </p>
                      <div
                        dangerouslySetInnerHTML={{ __html: roomDescription }}
                      />
                    </Fade>
                    </div>
                    <Fade cascade damping={0.2} direction="up" triggerOnce={true}>
                    <div className="singleroom_one_third themeborder">
                      <div className="singleroom_price_wrapper">
                        <div className="singleroom_price_label">From</div>
                        <div className="singleroom_price_amount">
                          <span className="mphb-price">
                            <span className="mphb-currency">NRS&nbsp;</span> 
                            {room?.room_price}
                          </span>{" "}
                          <span
                            className="mphb-price-period"
                            title="Choose dates to see relevant prices"
                          >
                            per night
                          </span>
                        </div>
                        {/*  */}
                        {/* <div id="be-booking-form"></div>  */}
                        {/*  */}
                        <a
                          id="singleroom_book"
                          data-formid="150"
                          href="/"
                          className="singleroom_book button"
                        >
                          Book Now
                        </a>
                        <div
                          id="singleroom_book_form150"
                          className="singleroom_book_form"
                        >
                          <div className="mphb_sc_booking_form-wrapper">
                            <form
                              method="GET"
                              action="https://themes.themegoods.com/hoteller/luxury/search-results/"
                              className="mphb-booking-form"
                              id="booking-form-150"
                            >
                              <p className="mphb-required-fields-tip">
                                <small>
                                  Required fields are followed by{" "}
                                  <abbr title="required">*</abbr>
                                </small>
                              </p>
                              <input
                                type="hidden"
                                id="mphb-checkout-nonce"
                                name="mphb-checkout-nonce"
                                value="738b75c68a"
                              />
                              <input
                                type="hidden"
                                name="_wp_http_referer"
                                value="/hoteller/luxury/accommodation/deluxe-room/"
                              />{" "}
                              <input
                                type="hidden"
                                name="mphb_room_type_id"
                                value="150"
                              />
                              <p className="mphb-check-in-date-wrapper">
                                <label>
                                  {" "}
                                  Check-in Date{" "}
                                  <abbr title="Formatted as dd/mm/yyyy">
                                    *
                                  </abbr>{" "}
                                </label>
                                <br />
                                <input
                                  id="mphb_check_in_date-60619c8d52529"
                                  type="text"
                                  className="mphb-datepick"
                                  value=""
                                  placeholder="Check-in Date"
                                />
                                <input
                                  id="mphb_check_in_date-60619c8d52529-hidden"
                                  type="hidden"
                                  name="mphb_check_in_date"
                                  value=""
                                />
                              </p>
                              <p className="mphb-check-out-date-wrapper">
                                <label>
                                  {" "}
                                  Check-out Date{" "}
                                  <abbr title="Formatted as dd/mm/yyyy">
                                    *
                                  </abbr>{" "}
                                </label>
                                <br />
                                <input
                                  id="mphb_check_out_date-60619c8d52529"
                                  type="text"
                                  className="mphb-datepick"
                                  value=""
                                  placeholder="Check-out Date"
                                />
                                <input
                                  id="mphb_check_out_date-60619c8d52529-hidden"
                                  type="hidden"
                                  name="mphb_check_out_date"
                                  value=""
                                />
                              </p>
                              <p className="mphb-adults-wrapper mphb-capacity-wrapper">
                                <label> Adults </label>
                                <br />
                                <select
                                  id="mphb_adults-60619c8d52529"
                                  name="mphb_adults"
                                >
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="8">8</option>
                                  <option value="9">9</option>
                                  <option value="10">10</option>
                                  <option value="11">11</option>
                                  <option value="12">12</option>
                                  <option value="13">13</option>
                                  <option value="14">14</option>
                                  <option value="15">15</option>
                                  <option value="16">16</option>
                                  <option value="17">17</option>
                                  <option value="18">18</option>
                                  <option value="19">19</option>
                                  <option value="20">20</option>
                                  <option value="21">21</option>
                                  <option value="22">22</option>
                                  <option value="23">23</option>
                                  <option value="24">24</option>
                                  <option value="25">25</option>
                                  <option value="26">26</option>
                                  <option value="27">27</option>
                                  <option value="28">28</option>
                                  <option value="29">29</option>
                                  <option value="30">30</option>
                                </select>
                              </p>
                              <p className="mphb-children-wrapper mphb-capacity-wrapper">
                                <label> Children </label>
                                <br />
                                <select
                                  id="mphb_children-60619c8d52529"
                                  name="mphb_children"
                                >
                                  <option value="0">0</option>
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="8">8</option>
                                  <option value="9">9</option>
                                  <option value="10">10</option>
                                </select>
                              </p>
                              <p className="mphb-reserve-btn-wrapper">
                                <input
                                  className="mphb-reserve-btn button"
                                  type="submit"
                                  value="Check Availability"
                                />
                                <span className="mphb-preloader mphb-hide"></span>
                              </p>
                              <div className="mphb-errors-wrapper mphb-hide"></div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <br className="clear" />
                      <div className="singleroom_attributes_wrapper">
                        <div className="singleroom_attribute">
                          <div className="singleroom_bed_icon room_icon">
                            <img src={bed} alt="Bed_type" />
                          </div>
                          <div className="singleroom_bed room_attribute">
                            King Bed
                          </div>
                        </div>

                        <div className="singleroom_attribute">
                          <div className="singleroom_adults_children_icon room_icon">
                            <img src={people} alt="Adults &amp; Children" />
                          </div>
                          <div className="singleroom_adults_children room_attribute">
                            {room?.attributes?.Adults}&nbsp;{room?.attributes?.Adults === 1 ? 'Adult' : 'Adults'}&nbsp; {room?.attributes?.Children}
                            &nbsp;{room?.attributes?.Children === 1 ? 'Child' : 'Children'}&nbsp;
                          </div>
                        </div>

                        <div className="singleroom_attribute">
                          <div className="singleroom_size_icon room_icon">
                            <img src={icon_size} alt="Size" />
                          </div>
                          <div className="singleroom_size room_attribute">
                            {room?.attributes?.Area} sq m
                          </div>
                        </div>

                        <div className="singleroom_attribute">
                          <div className="singleroom_view_icon room_icon">
                            <img src={icon_view} alt="View" />
                          </div>
                          <div className="singleroom_view room_attribute">
                            City view
                          </div>
                        </div>

                        <div className="sidebar">
                          <div className="content"></div>
                        </div>
                      </div>
                    </div>
                    </Fade>
                  </div>
                ))}
              </div>
              {/* <!-- End each blog post --> */}
            </div>
          </div>
          {/* <!-- End main content --> */}
        </div>

        <br className="clear" />
        <Element name="singleroom_amenities"></Element>
      </div>
    </>
  );
};

export default RoomInfo;
